import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'report-hub',
  version: '1.0.0',
  properties: [
    // ============================================
    // PARAMETERS TAB - REPORT CONFIGURATION
    // ============================================
    {
      key: 'reportName',
      label: 'Report Name',
      type: 'string',
      required: true,
      placeholder: 'e.g., Monthly Sales Report or {{ $node["NodeName"].string }}',
      description: 'Name/title of the report (supports expressions)',
      supportsExpressions: true,
      section: 'properties',
    },
    {
      key: 'description',
      label: 'Description',
      type: 'string',
      required: false,
      default: '',
      placeholder: 'Optional description of the report...',
      description: 'Optional description of the report',
      typeOptions: {
        rows: 2,
      },
      section: 'properties',
    },
    {
      key: 'contentType',
      label: 'Content Type',
      type: 'options',
      required: true,
      default: 'auto',
      options: [
        {
          value: 'auto',
          name: 'Auto-detect',
          description: 'Automatically detect from input data',
        },
        {
          value: 'html',
          name: 'HTML',
          description: 'HTML content for rendering in iframe',
        },
        {
          value: 'pdf',
          name: 'PDF',
          description: 'PDF document',
        },
        {
          value: 'image',
          name: 'Image',
          description: 'Image file (PNG, JPG, etc.)',
        },
        {
          value: 'binary',
          name: 'Other Binary',
          description: 'Any other file type',
        },
      ],
      description: 'Type of content being published',
      section: 'properties',
    },
    {
      key: 'content',
      label: 'Content',
      type: 'string',
      required: false,
      placeholder: '{{ $node["NodeName"].html }}',
      description:
        'Expression to extract content from previous node. For HTML use {{ $node["NodeName"].html }}, for binary use {{ $node["NodeName"].binary }}.',
      supportsExpressions: true,
      section: 'properties',
    },
    {
      key: 'fileName',
      label: 'File Name',
      type: 'string',
      required: false,
      default: '',
      placeholder: 'report.pdf',
      description: 'File name for binary content (auto-detected if empty)',
      supportsExpressions: true,
      section: 'properties',
      displayOptions: {
        show: {
          contentType: ['pdf', 'image', 'binary', 'auto'],
        },
      },
    },
    {
      key: 'overwriteExisting',
      label: 'Overwrite Existing',
      type: 'boolean',
      required: false,
      default: false,
      description:
        'If enabled, reports with the same name will be overwritten instead of creating duplicates.',
      section: 'properties',
    },

    // ============================================
    // DEPLOYMENT TAB - ACCESS CONTROL
    // ============================================
    {
      key: 'allowedUsers',
      label: 'Visible to',
      type: 'chatVisibility',
      default: [],
      required: false,
      description:
        'Select users who can see this report in the Report Hub MFE. Leave empty for workflow owner only.',
      section: 'deployment',
    },
  ],
};

export default schema;
